"use client"

import { reatomComponent } from "@reatom/react"
import { type PropsWithChildren, useMemo } from "react"
import { setLaunchedCollectionSlugs } from "./collection-path"

interface Props extends PropsWithChildren {
  launches: ReadonlyArray<{ collectionId: string; slug?: string }>
}

/**
 * Gives `getCollectionHref` the launched collections' slugs the root layout
 * read, in server rendering and in the browser. It registers them while it
 * renders, so every link below it already uses them.
 */
export const LaunchedCollectionSlugs = reatomComponent<Props>(
  ({ launches, children }) => {
    useMemo(() => setLaunchedCollectionSlugs(launches), [launches])
    return <>{children}</>
  },
  "LaunchedCollectionSlugs",
)
